import { Calendar } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';
import { formatQuickDateLabel } from '../../utils/quickCreateDates';

/**
 * Visual trigger for the quick-create date picker sheet.
 * Native `<input type="date">` is intentionally avoided inside Radix BottomSheets —
 * the UA calendar sits outside the dialog and cannot be used (pointer-events / dismiss).
 */
export function QuickCreateDateControl({
  value,
  onClick,
  ariaLabel,
  formatLabel = formatQuickDateLabel,
  className,
  disabled,
}) {
  const label = formatLabel(value);

  return (
    <div className={cn('relative min-w-0', className)}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-haspopup="dialog"
        className={cn(
          'flex min-h-[46px] w-full min-w-0 items-center gap-2 rounded-xl border border-border bg-card px-3.5 text-left text-sm transition-colors',
          'hover:border-sage-300 disabled:cursor-not-allowed disabled:opacity-50',
        )}
      >
        <span className="min-w-0 flex-1 truncate font-medium text-foreground">
          {label}
        </span>
        <Calendar className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
      </button>
    </div>
  );
}
